import React from 'react';
import { FilterFormProps } from '../../types';
import { FilterInput } from './FilterInput';

/**
 * FilterForm component.
 *
 * WHAT: Renders filter inputs in a horizontal inline layout.
 *
 * WHY: Matches the old reports module styling where filters are
 * displayed inline in a row with spacing between them.
 *
 * HOW: Uses flexbox with display: inherit from parent container
 * to create horizontal layout. Each filter item has right margin.
 */
export const FilterForm: React.FC<FilterFormProps> = ({
  filters,
  values,
  errors,
  onChange,
  onBlur,
  getOptions,
  isLoadingOptions,
  disabled = false
}) => {
  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <>
      {filters.map((filter) => {
        // Get options from SDK hook if available, otherwise use static options
        const options = getOptions
          ? getOptions(filter.id)
          : filter.options ?? [];
        const optionsLoading = isLoadingOptions
          ? isLoadingOptions(filter.id)
          : false;

        return (
          <FilterInput
            key={filter.id}
            filter={filter}
            value={values[filter.id]}
            error={errors[filter.id]}
            onChange={(value) => onChange(filter.id, value)}
            onBlur={() => onBlur && onBlur(filter.id)}
            options={options}
            optionsLoading={optionsLoading}
            disabled={disabled}
          />
        );
      })}
    </>
  );
};

export default React.memo(FilterForm);
